/*
 * @Descripttion: 微信小程序数据
 * @Author: xutao
 * @Date: 2020-11-01 17:50:05
 * @LastEditors: kuanggf
 * @LastEditTime: 2021-12-09 16:30:57
 * @FilePath: \yunjiactivity-h5\src\common\define\wxConstData.js
 */
import Vue from 'vue'
import axios from 'axios'
import { isTestEnv } from '../utils/commonUtil'
/**
 * “云集”微信小程序原始ID
 */
export let yunjiWXAppOriginId = 'gh_92153ab78660'
/**
 * “全球精选特卖1”微信小程序原始ID
 */
export let yunjiSpeWXAppOriginId = 'gh_99069a742b71'

const usernameObj = {
  yunjiWXAppOriginId: 'gh_92153ab78660',
  yunjiSpeWXAppOriginId: 'gh_99069a742b71',
  appId: 'wxfe4380f4c0fa7571',
  applicationAppId: 'wxfe4380f4c0fa7571',
}

const observer = Vue.observable(usernameObj)

const API_APPLET_CONFIG = {
  test: 'https://t-do-dev.yunjiglobal.com/yunjiuserapp/userapp/getAppletConfig',
  release: `${window.location.origin}/yunjiuserapp/userapp/getAppletConfig.json`
}

const requestUsername = () => {
  console.log('从接口获取云集小程序原始id ===>')
  axios({
    url: isTestEnv() ? API_APPLET_CONFIG.test :API_APPLET_CONFIG.release ,
    method: 'get',
    responseType: 'json',
    withCredentials: true
  }).then(res => {
    console.log(res)
    if (res.status < 200 || res.status > 299) return
    res = res.data
    if (res.code !== 0 || !res.data) return
    const { sourceId, appId, applicationAppId } = res.data
    observer.yunjiWXAppOriginId = sourceId
    observer.yunjiSpeWXAppOriginId = sourceId
    observer.appId = appId
    observer.applicationAppId = applicationAppId
    console.log('<=== 从接口获取云集小程序原始id done.', res)
  })
}

requestUsername()

export default observer